<template>
  <div>
    <div>
      <el-form
        ref="formRef"
        :model="formData"
        label-width="135px"
        :rules="createFormRules"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="活动名称" prop="campaignName">
              <el-input
                :disabled="flag == 3"
                v-model="formData.campaignName"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="活动时间 从" prop="startDate">
              <el-date-picker
                :disabled="flag == 3"
                style="width: 50%"
                v-model="formData.startDate"
                type="date"
                placeholder="开始日期"
              >
              </el-date-picker>
              <span>(含)</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="(含) 至" prop="endDate">
              <el-date-picker
                :disabled="flag == 3"
                style="width: 50%"
                v-model="formData.endDate"
                type="date"
                placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="销售门店">
              <el-radio-group
                :disabled="flag == 3"
                v-model="formData.isAllShop"
                @change="shopRadioChange"
              >
                <el-radio :label="true">所有门店</el-radio>
                <el-radio :label="false">部分门店</el-radio>
              </el-radio-group>
              <el-button
                style="margin-left: 10px"
                :disabled="formData.isAllShop == true"
                @click="outletVisible = true"
                >选择门店</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              prop="listOfSomeStoreslStr"
              :rules="
                formData.isAllShop == false
                  ? [
                      {
                        required: true,
                        message: '请选择部分门店',
                        trigger: 'blur',
                      },
                    ]
                  : [{ required: false }]
              "
            >
              <textarea
                style="width: 50%"
                rows="8"
                readonly
                v-model="formData.listOfSomeStoreslStr"
              ></textarea>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="用户类型" prop="joinCustomerFlag">
              <el-select
                :disabled="flag == 3"
                v-model="formData.joinCustomerFlag"
                @change="changeJoinCustomerFlag"
              >
                <el-option
                  v-for="item in customerType"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="formData.joinCustomerFlag == 14">
          <el-col :span="24">
            <el-form-item
              label="用户分组"
              prop="custGrpName"
              :rules="
                formData.joinCustomerFlag == 14
                  ? [
                      {
                        required: true,
                        message: '请选择用户分组',
                        trigger: 'blur',
                      },
                    ]
                  : [{ required: false }]
              "
            >
              <div>
                <el-input
                  :disabled="flag == 3"
                  style="width: 90%"
                  readonly
                  v-model="formData.custGrpName"
                ></el-input>
                <el-button @click="userGroupingShow = true">选择分组</el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="formData.joinCustomerFlag == 3">
          <el-col :span="24">
            <el-form-item
              label="会员等级"
              prop="custLvl"
              :rules="
                formData.joinCustomerFlag == 3
                  ? [
                      {
                        type: 'array',
                        required: true,
                        message: '请至少选择一个会员等级',
                        trigger: 'change',
                      },
                    ]
                  : [{ required: false }]
              "
            >
              <el-checkbox
                :disabled="flag == 3"
                v-model="formData.custLvl"
                v-for="item in checkbooksData"
                :key="item.levelID"
                :value="item.levelID"
                :label="item.levelID"
              >
                {{ item.levelName_cn }}
              </el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-form-item label="活动限制">
            <el-col :span="10">
              <el-radio-group
                :disabled="flag == 3"
                v-model="formData.actLimit"
                @change="shopRadioChange"
              >
                <el-radio :label="0">无限制</el-radio>
                <el-radio :label="3">有限制 每个会员</el-radio>
              </el-radio-group>
            </el-col>

            <el-col :span="10">
              <el-select
                v-model="formData.wholeOrDay"
                :disabled="flag == 3 ? true : formData.actLimit == 0"
              >
                <el-option value="2" label="总共"></el-option>
                <el-option value="1" label="每天"></el-option>
              </el-select>
            </el-col>
            <el-col :span="3" style="display: flex">
              <el-input
                v-model="formData.limitNum"
                :disabled="flag == 3 ? true : formData.actLimit == 0"
              ></el-input
              >次
            </el-col>
          </el-form-item>
        </el-row>

        <el-row>
          <el-col>
            <el-form-item label="销售单范围">
              <el-radio-group
                :disabled="flag == 3"
                v-model="formData.saleScope"
              >
                <el-radio :label="0">无限制</el-radio>
                <el-radio :label="1">会员生日当月销售单</el-radio>
                <el-radio :label="2">会员生日当天销售单</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="销售单限制">
              <el-radio-group
                :disabled="flag == 3"
                v-model="formData.saleLimit"
                @change="changeSaleLimit"
              >
                <el-radio :label="0">无限制</el-radio>
                <el-radio :label="1">会员首单金额满足</el-radio>
                <el-radio :label="2">单笔金额满足</el-radio>
                <el-radio :label="3">购买特定商品满足</el-radio>
              </el-radio-group>
              <el-select
                v-model="formData.specProductFlag"
                :disabled="flag == 3 ? true : formData.saleLimit != 3"
                @change="changeSpecProductFlag"
              >
                <el-option value="1" label="商品编码"></el-option>
                <el-option value="2" label="商品标签"></el-option>
                <el-option value="3" label="类别编码"></el-option>
                <el-option value="4" label="类别标签"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="formData.saleLimit == 1 || formData.saleLimit == 2">
          <el-col :span="11">
            <el-form-item
              label="销售金额"
              prop="minAmount"
              :rules="
                formData.saleLimit == 1 || formData.saleLimit == 2
                  ? [
                      {
                        required: true,
                        message: '请输入最小消费金额',
                        trigger: 'blur',
                      },
                    ]
                  : [{ required: false }]
              "
            >
              <el-input
                :disabled="flag == 3"
                v-model="formData.minAmount"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="1"><span>(含) </span> </el-col>
          <el-col :span="11">
            <el-form-item label="至">
              <el-input
                :disabled="flag == 3"
                v-model="formData.maxAmount"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="1"> <span>(含)</span></el-col>
        </el-row>

        <el-row v-if="formData.saleLimit == 3">
          <SelectProduct ref="Prod"></SelectProduct>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="活动内容">
              <el-radio-group
                :disabled="flag == 3"
                v-model="formData.presentedKind"
              >
                <el-radio :label="0">礼券</el-radio>
                <el-radio :label="1" v-if="formData.joinCustomerFlag != 0"
                  >券包</el-radio
                >
                <el-radio :label="2" v-if="formData.joinCustomerFlag != 0"
                  >积分</el-radio
                >
                <el-radio :label="3" v-if="formData.joinCustomerFlag != 0"
                  >短信</el-radio
                >
                <el-radio :label="4" v-if="formData.joinCustomerFlag != 0"
                  >彩信</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="formData.presentedKind == 0">
          <el-col :span="24">
            <el-form-item
              label="券库"
              prop="presentedqk"
              :rules="
                formData.presentedKind == 0
                  ? [
                      {
                        required: true,
                        message: '请选择券库',
                        trigger: 'change',
                      },
                    ]
                  : [{ required: false }]
              "
            >
              <div class="xiaoguo">
                <el-input
                  readonly
                  style="width: 90%"
                  v-model="formData.presentedqk"
                  @click.native="Juankubtn"
                ></el-input>
                <el-button :disabled="flag == 3" @click="weachTher"
                  >选择</el-button
                >
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="formData.presentedKind == 1">
          <el-col :span="24">
            <div class="xiaoguo">
              <el-form-item
                label="券包"
                prop="presentedqb"
                :rules="
                  formData.presentedKind == 1
                    ? [
                        {
                          required: true,
                          message: '请选择券包',
                          trigger: 'blur',
                        },
                      ]
                    : [{ required: false }]
                "
              >
                <el-input
                  readonly
                  v-model="formData.presentedqb"
                  style="width: 90%"
                  @click.native="Juanbaobtn"
                ></el-input>
                <el-button
                  :disabled="
                    flag == 3
                      ? true
                      : formData.presentedKind == 1
                      ? false
                      : true
                  "
                  @click="weachTherqb"
                  >选择</el-button
                >
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row
          v-if="formData.presentedKind == 0 || formData.presentedKind == 1"
        >
          <el-col :span="24">
            <el-form-item
              label="发放数量"
              prop="sendMaxQty"
              :rules="
                formData.presentedKind == 0 || formData.presentedKind == 1
                  ? [
                      {
                        required: true,
                        message: '请输入发放数量',
                        trigger: 'blur',
                      },
                    ]
                  : [{ required: false }]
              "
            >
              <el-input
                :disabled="flag == 3"
                placeholder="如果填0则表示不限制发放数量"
                v-model="formData.sendMaxQty"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="formData.presentedKind == 2">
          <el-col :span="24">
            <el-form-item
              label="赠送积分"
              prop="presentedObjID2"
              :rules="
                formData.presentedKind == 2
                  ? [
                      {
                        required: true,
                        message: '请输入赠送积分',
                        trigger: 'blur',
                      },
                    ]
                  : [{ required: false }]
              "
            >
              <el-input
                oninput="value=value.replace(/[^0-9]/g,'')"
                :disabled="flag == 3"
                v-model="formData.presentedObjID2"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="formData.presentedKind == 3">
          <el-col :span="24">
            <el-form-item
              label="短信"
              prop="smsBody"
              :rules="
                formData.presentedKind == 3
                  ? [
                      {
                        required: true,
                        message: '请输入短信',
                        trigger: 'blur',
                      },
                    ]
                  : [{ required: false }]
              "
            >
              <el-input
                :disabled="flag == 3"
                v-model="formData.smsBody"
                type="textarea"
                rows="5"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="formData.presentedKind == 4">
          <el-col :span="24">
            <el-form-item
              label="彩信ID"
              prop="presentedObjID4"
              :rules="
                formData.presentedKind == 4
                  ? [
                      {
                        required: true,
                        message: '请输入彩信id',
                        trigger: 'blur',
                      },
                    ]
                  : [{ required: false }]
              "
            >
              <el-input
                :disabled="flag == 3"
                v-model="formData.presentedObjID4"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="formData.presentedKind != 2">
          <el-col :span="24">
            <el-form-item label="抄送人员">
              <el-input
                :disabled="flag == 3"
                readonly
                style="width: 90%"
                v-model="formData.chaosong"
              ></el-input>
              <el-button
                :disabled="flag == 3"
                @click="sysempselectEmpList(), (innerVisiblery = true)"
                >选择</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="发放方式">
              <el-radio-group
                  :disabled="flag == 3"
                  v-model="formData.sendMode"
                  @change="sendModeRadioChange"
              >
                <el-radio :label="0">立即发送</el-radio>
                <el-radio :label="1">定时发送</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="发放取消规则"
                          prop="saleLimieFlag"
                          :rules="
              formData.sendMode == 1
                ? [
                    {
                      required: true,
                      message: '请选择发放取消规则',
                      trigger: 'blur',
                    },
                  ]
                : [{ required: false }]
            "
            >
              <el-select
                  :disabled="
                flag == 3 ? true : formData.sendMode == 1 ? false : true
              "
                  v-model="formData.saleLimieFlag"
              >
                <el-option
                    v-for="item in saleLimieFlagType"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item style="width: 57%" label="发放间隔天数"
                          :rules="
              formData.sendMode == 1
                ? [
                    {
                      required: true,
                       message: '请输入发放间隔天数',
                      trigger: 'blur',
                    },
                  ]
                : [{ required: false }]
            "
            >
              <el-input
                  oninput="value=value.replace(/[^0-9]/g,'')"
                  :disabled="
                flag == 3 ? true : formData.sendMode == 1 ? false : true
              "
                  v-model="formData.disIntervalDay"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item
                label="定时发送时间点"
                prop="issueTime"
                :rules="
              formData.sendMode == 1
                ? [
                    {
                      required: true,
                      message: '请选择定时发送时间',
                      trigger: 'blur',
                    },
                  ]
                : [{ required: false }]
            "
            >
              <el-time-picker
                  value-format="HH:mm:ss"
                  style="width: 36%; margin-left: 10px"
                  v-model="formData.issueTime"
                  placeholder="任意时间点"
                  :disabled="
                flag == 3 ? true : formData.sendMode == 1 ? false : true
              "
              >
              </el-time-picker>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button v-if="flag != 3" @click="formRules">保存</el-button>
        <el-button @click="cancel">取消</el-button>
      </div>

      <div class="outlet">
        <!-- 选择门店弹窗 -->
        <div class="outlet">
          <el-dialog
            append-to-body
            width="30%"
            :visible.sync="outletVisible"
            title="选择门店"
          >
            <el-form size="mini" label-width="90px">
              <el-row
                :gutter="50"
                v-for="(item, index) in StoreSelectionList"
                :key="index"
              >
                <el-col
                  :span="12"
                  v-for="(myitem, myindex) in item"
                  :key="myindex"
                >
                  <el-tree
                    ref="tree"
                    v-if="myitem != undefined"
                    :data="[myitem]"
                    show-checkbox
                    node-key="ShopID"
                    highlight-current
                    default-expand-all
                    :default-checked-keys="shopId"
                    :props="defaultProps"
                  >
                  </el-tree>
                </el-col>
              </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="ComButtomStore">确 定</el-button>
              <el-button @click="outletVisible = false">取 消</el-button>
            </div>
          </el-dialog>
        </div>
      </div>

      <!-- 选择劵库弹窗 -->
      <div>
        <el-dialog
          width="40%"
          title="选择券库"
          append-to-body
          :visible.sync="innerVisible"
          :close-on-click-modal="false"
        >
          <el-form size="mini" label-width="120px">
            <el-row>
              <el-col :span="12">
                <el-form-item label="券名称">
                  <el-input v-model="queryArr.couponsName"> </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="券类型">
                  <div class="flex-between">
                    <el-select
                      style="width: 100%"
                      v-model="queryArr.couponsKind"
                    >
                      <el-option label="全部" value=""> </el-option>
                      <el-option label="现金券" value="0"> </el-option>
                      <el-option label="折扣券" value="1"> </el-option>
                      <el-option label="礼品券" value="2"> </el-option>
                      <el-option label="异业券" value="3"> </el-option>
                    </el-select>
                    <el-button
                      icon="el-icon-search"
                      style="margin-left: 3%"
                      @click="Securitieslibrary()"
                      >查询</el-button
                    >
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="创建时间">
                  <el-date-picker
                    v-model="queryArr.createTime"
                    type="date"
                    placeholder="选择时间"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="至">
                  <el-date-picker
                    v-model="queryArr.updateTime"
                    type="date"
                    placeholder="选择时间"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div style="width: 100%; margin-top: 10px">
            <el-table
              height="300"
              class="table-style"
              border
              :row-class-name="tableRowClassName"
              :header-cell-style="{
                background: '#FCFBF2',
                color: '#6C6839',
                'text-align': 'center',
              }"
              :cell-style="{ 'text-align': 'center' }"
              ref="multipleTable"
              :data="queryList"
              tooltip-effect="dark"
              v-el-table-infinite-scroll="load"
              v-loading="loading"
              infinite-scroll-disabled="onLoading"
            >
              <el-table-column width="40">
                <template slot-scope="scope">
                  <el-radio
                    v-model="radioId"
                    :label="scope.$index"
                    @change.native="handleRadioChange(scope.row)"
                    >&nbsp;
                  </el-radio>
                </template>
              </el-table-column>
              <el-table-column prop="couponsName" label="券名称">
              </el-table-column>
              <el-table-column prop="innerCoupName" label="券后台名称">
              </el-table-column>
              <el-table-column prop="couponsKind" label="券类型">
                <template scope="scope">
                  {{
                    scope.row.couponsKind === 0
                      ? " 现金券"
                      : "" || scope.row.couponsKind === 1
                      ? "折扣券"
                      : "" || scope.row.couponsKind === 2
                      ? "礼品券"
                      : "" || scope.row.couponsKind === 3
                      ? "异业券"
                      : ""
                  }}
                </template>
              </el-table-column>
              <el-table-column prop="coupValue" label="券值"></el-table-column>
              <el-table-column prop="giftNo" label="礼品编号"></el-table-column>
              <el-table-column
                prop="giftName"
                label="礼品名称"
              ></el-table-column>
              <el-table-column prop="createUserName" label="创建人">
              </el-table-column>
              <el-table-column prop="createTime" label="创建时间">
                <template scope="scope">
                  {{ scope.row.createTime | dateFormats }}
                </template>
              </el-table-column>
            </el-table>
            <el-alert
              v-if="isMore"
              title="没有更多啦!"
              type="warning"
              center
              show-icon
              :closable="false"
            >
            </el-alert>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="determine">确 定</el-button>
            <el-button @click="innerVisible = false">取 消</el-button>
          </div>
        </el-dialog>
      </div>

      <!-- 选择券包 -->
      <div class="choice">
        <el-dialog
          width="35%"
          title="选择券包"
          append-to-body
          :visible.sync="innerVisibleqb"
        >
          <el-form size="mini" label-width="100px">
            <el-row>
              <el-col>
                <el-form-item label="券包名称">
                  <el-input
                    style="width: 60%"
                    v-model="queryArrqb.coupPacketName"
                  ></el-input>
                  <el-button
                    icon="el-icon-search"
                    style="margin-left: 3%"
                    @click="Seachbtnerqb"
                    >查询</el-button
                  >
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <div style="width: 100%">
            <el-table
              size="mini"
              height="300"
              class="table-style"
              border
              :row-class-name="tableRowClassName"
              :header-cell-style="{
                background: '#FCFBF2',
                color: '#6C6839',
                'text-align': 'center',
              }"
              :cell-style="{ 'text-align': 'center' }"
              ref="multipleTable"
              :data="queryListqb"
              tooltip-effect="dark"
              v-el-table-infinite-scroll="loadqb"
              v-loading="loadingqb"
              infinite-scroll-disabled="onLoadingqb"
            >
              <el-table-column label width="35">
                <template slot-scope="scope">
                  <el-radio
                    v-model="radioIdqb"
                    :label="scope.$index"
                    @change.native="handleRadioChangeqb(scope.row)"
                    >&nbsp;
                  </el-radio>
                </template>
              </el-table-column>
              <el-table-column prop="coupPacketName" label="券名称">
              </el-table-column>
            </el-table>
            <el-alert
              v-if="isMoreqb"
              title="没有更多啦!"
              type="warning"
              center
              show-icon
              :closable="false"
            >
            </el-alert>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="Determineqb">确 定</el-button>
            <el-button @click="innerVisibleqb = false">取 消</el-button>
          </div>
        </el-dialog>
      </div>

      <!-- 选择员工 -->
      <div class="choice">
        <el-dialog
          append-to-body
          width="45%"
          title="选择员工"
          :visible.sync="innerVisiblery"
        >
          <el-form size="mini" label-width="200px">
            <el-form-item label="会员姓名\会员卡号\手机号">
              <div class="flex-between">
                <el-input style="width: 300px" v-model="queryArrry.search">
                </el-input>
                <el-button
                  style="
                    width: 80px;
                    margin-left: 10px;
                    background-color: #f1f1f1;
                    color: #b6b388;
                  "
                  size="mini"
                  icon="el-icon-search"
                  @click="sysempselectEmpList()"
                  >查询</el-button
                >
              </div>
            </el-form-item>
          </el-form>
          <div style="width: 100%">
            <el-table
              size="mini"
              height="300"
              class="table-style"
              border
              :row-class-name="tableRowClassName"
              :header-cell-style="{
                background: '#FCFBF2',
                color: '#6C6839',
                'text-align': 'center',
              }"
              :cell-style="{ 'text-align': 'center' }"
              ref="multipleTable"
              :data="queryListry"
              tooltip-effect="dark"
              v-el-table-infinite-scroll="loadry"
              v-loading="loadingry"
              infinite-scroll-disabled="onLoadingry"
              @select="handleSelectionChange"
            >
              <el-table-column type="index" width="50"> </el-table-column>
              <el-table-column type="selection" label="选择" width="50">
              </el-table-column>
              <el-table-column prop="cardNo" label="会员卡号">
              </el-table-column>
              <el-table-column prop="custName" label="会员姓名">
              </el-table-column>
              <el-table-column prop="mobile" label="手机号"> </el-table-column>
              <el-table-column prop="levelName" label="消费等级">
              </el-table-column>
              <el-table-column prop="regionName" label="所属区域">
              </el-table-column>
              <el-table-column prop="shopName" label="所属门店">
              </el-table-column>
              <el-table-column prop="serviceEmpName" label="维护品牌顾问">
              </el-table-column>
            </el-table>
            <el-alert
              v-if="isMorery"
              title="没有更多啦!"
              type="warning"
              center
              show-icon
              :closable="false"
            >
            </el-alert>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="Selectemployees">确 定</el-button>
            <el-button @click="innerVisiblery = false">取 消</el-button>
          </div>
        </el-dialog>

        <div class="alteration">
          <el-dialog
            append-to-body
            width="50%"
            title="选择分组"
            :visible.sync="userGroupingShow"
            :close-on-click-modal="false"
          >
            <userGrouping
              @submit="getChangeProductInfo"
              @close="userGroupingShow = false"
              ref="scanCodeDialogRef"
            ></userGrouping>
          </el-dialog>
          <el-dialog
            append-to-body
            width="80%"
            title="券库详情"
            :visible.sync="quankuShow"
            :close-on-click-modal="false"
          >
            <quanku ref="quanku"></quanku>
          </el-dialog>
          <el-dialog
            append-to-body
            width="80%"
            title="券包详情"
            :visible.sync="quanbaoShow"
            :close-on-click-modal="false"
          >
            <quanbao ref="quanbao"></quanbao>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SelectProduct from "/src/components/selectGivenProduct/index.vue";
import userGrouping from "/src/components/userGrouping/index.vue";
import { queryLSelectApi } from "@/api/user"; // 会员等级接口
import { getcpyNo } from "@/utils/auth";
import { dateTimes } from "@/utils/auth";
import quanku from "/src/components/quanku.vue";
import quanbao from "/src/components/quanbao.vue";

import {
  shopQueryRegionApi,
  couponsGroupApi,
  couppacketJuanApi,
  marketingEitApi,
  marketingInsertApi,
  custselectCustList,
} from "@/api/marketing";
export default {
  name: "createdEditSingleTime",
  components: {
    SelectProduct: SelectProduct,
    userGrouping: userGrouping,
    quanku: quanku,
    quanbao: quanbao,
  },
  data() {
    return {
      quanbaoShow: false,
      quankuShow: false,
      userGroupingShow: false,
      mouthOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      dayOptions: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28,
      ],
      formData: {
        couponsKind: "",
        campaignName: "",
        isAllShop: true,
        custLvl: [],
        CCID: [],
        runTimeFlag: 0,
        sendMode: 0,
        saleLimieFlag: '',
        disIntervalDay: 0,
        issueTime: '',
        presentedKind: 0,
        chaosong: "",
        listOfSomeStoresl: [],
        ccMap: [],
        actLimit: 0,
        saleLimit: 0,
        saleScope: 0,
        specProductFlag: "1",
        custGrpName: "",
        customerGrpID: "",
      }, //表单数据
      radioChangeShop: true,
      // 定时发放时销售单限制
      saleLimieFlagType: [
        {
          value: 0,
          label: "不取消",
        },
        {
          value: 1,
          label: "原销售单仅全部退货时取消",
        },
        {
          value: 2,
          label: "原销售单退货时取消",
        },
      ],
      // 用户类型
      customerType: [
        {
          value: 1,
          label: "所有会员",
        },
        {
          value: 2,
          label: "VIC会员",
        },
        {
          value: 3,
          label: "会员等级",
        },
        {
          value: 10,
          label: "本月生日会员",
        },
        {
          value: 11,
          label: "生日当天会员",
        },
        {
          value: 12,
          label: "本月注册会员",
        },
        {
          value: 13,
          label: "今年注册会员",
        },
        {
          value: 14,
          label: "会员分组",
        },
      ],
      radioDisabled1: false,
      selectStoreDialog: false, //选择门店弹窗
      selectShopData: [], // 门店树形图数据
      defaultProps: {
        children: "chlidren",
        label: "lable",
      },

      queryList: [], //选择劵库弹窗数据

      queryArr: {
        state: 0,
        couponsName: "", //卷名称
        couponsKind: "", //卷类型
        createTime: "",
        updateTime: "",
        pageSize: 50,
        pageNo: 1,
        pages: 0,
      }, // 内层弹窗请求数据
      loading: false,
      innerVisible: false, //券库弹窗
      // 选择券库radio数据
      radioId: "",
      // 券库券分类ID
      couponsKind: "",
      templatei: {},
      // 内层弹窗请求数据
      queryArrqb: {
        state: 0,
        pageSize: 50,
        pageNo: 1,
        pages: 0,
        coupPacketName: "",
      },
      innerVisibleqb: false,
      // 选择券包loadingqb
      loadingqb: false,
      // 选择券包弹窗数据
      queryListqb: [],
      radioIdqb: "", //券包是否选中
      innerVisiblery: false, //选择抄送人员弹窗
      // 选择人员参数
      queryArrry: {
        empCode: "", //员工编号
        empName: "", //员工姓名
        empKind: "", //员工类型
        shopNameOrCode: "", // 门店编号\名称
        pageSize: 50,
        pageNo: 1,
        pages: 0,
      },
      loadingry: false,
      // 选择抄送人员数据
      queryListry: [],
      arrry: [],
      listOfSomeStoreslStr: "", // 选择门店
      outletVisible: false, //选择门店弹窗
      // 选择门店数据
      StoreSelectionList: [],
      StoredataArray: [],
      StoreSelectLength: 0,
      shopId: [],
      flag: 0,
      checkbooksData: [],
      createFormRules: {
        campaignName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
        ],
        startDate: [
          { required: true, message: "请选择开始时间", trigger: "blur" },
        ],
        endDate: [
          { required: true, message: "请选择结束时间", trigger: "blur" },
        ],
        joinCustomerFlag: [
          { required: true, message: "请选择用户类型", trigger: "change" },
        ],
        runMonth: [
          { required: true, message: "请选择执行月", trigger: "blur" },
        ],
        runDay: [{ required: true, message: "请选择执行日", trigger: "blur" }],
        timeRange: [
          { required: true, message: "请选择执行时间", trigger: "blur" },
        ],
        listOfSomeStoreslStr: [
          { required: true, message: "请选择门店", trigger: "blur" },
        ],
        custLvl: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个会员等级",
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    // 选择券库弹窗
    isMore() {
      //当起始页数等于总页数时停止加载
      return this.queryArr.pageNo >= this.queryArr.pages;
    },
    onLoading() {
      return this.loading || this.isMore;
    },
    // 选择券包弹窗
    isMoreqb() {
      //当起始页数等于总页数时停止加载
      return this.queryArrqb.pageNo >= this.queryArrqb.pages;
    },
    onLoadingqb() {
      return this.loadingqb || this.isMoreqb;
    },
    // 选择人员弹窗
    isMorery() {
      //当起始页数等于总页数时停止加载
      return this.queryArrry.pageNo >= this.queryArrry.pages;
    },
    onLoadingry() {
      return this.loadingry || this.isMorery;
    },
    ...mapState(["confirmButtonText", "cancelButtonText"]),
    isStoreSelectionMethod() {
      if (this.formData.isAllShop == "0") {
        return "listOfSomeStoreslStr";
      } else {
        return "Str";
      }
    },
  },
  created() {
    this.ShopqueryRegionList();
    queryLSelectApi({ cpyNO: getcpyNo() }).then((res) => {
      this.checkbooksData = res.data;
    });
  },

  methods: {
    //选择人员列表触底加载
    loadry() {
      console.log("触底啦");
      this.loadingry = true;
      setTimeout(() => {
        this.queryArrry.pageSize += 50; //页数据+50
        this.sysempselectEmpList(); // 重新获取数据，此时页数据+50
      });
    },
    formRules() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.submit();
        }
      });
      return;
    },
    getChangeProductInfo(data) {
      console.log(data);
      this.formData.custGrpName = data.custGrpName;
      this.formData.customerGrpID = data.customerGrpID;
      this.userGroupingShow = false;
    },
    changeSaleLimit(index) {
      if (index == 3) {
        this.formData.specProductFlag = "1";
        // this.$set(this.formData, "specProductFlag", '1');
        this.$nextTick(() => {
          this.$refs.Prod.parentHandleclick(1);
        });
      }
    },
    //特定商品选择触发
    changeSpecProductFlag(index) {
      console.log(index);
      this.$nextTick(() => {
        this.$refs.Prod.parentHandleclick(index);
      });
    },
    //接口调用成功返回
    success() {
      this.formData = {};
      this.disable = false;
      this.shopId = [];
      this.flag = 0;
      this.$emit("success");
    },
    //取消
    cancel() {
      this.formData = {
        couponsKind: "",
        campaignName: "",
        isAllShop: true,
        custLvl: [],
        CCID: [],
        runTimeFlag: 0,
        sendMode: 0,
        presentedKind: 0,
        chaosong: "",
        listOfSomeStoresl: [],
        ccMap: [],
        actLimit: 0,
        saleLimit: 0,
        saleScope: 0,
        specProductFlag: "1",
        custGrpName: "",
        customerGrpID: "",
      };
      this.disable = false;
      this.shopId = [];
      this.flag = 0;
      this.$emit("close");
    },
    //监听用户选择
    changeJoinCustomerFlag(e) {
      if (e == 0) {
        this.formData.presentedKind = 0;
      }
    },
    //确定
    submit() {
      console.log(this.formData.ccMap);
      let atrrValue = []; //编码数据
      let lblID = []; //标签数据
      if (!this.formData.ccMap) {
        this.formData.ccMap = [];
      }
      if (this.formData.saleLimit == 3) {
        let SelectCategoryLabelData =
          this.$refs.Prod.searchCategoryLabelFormhy.SelectCategoryLabelData; //类别标签数据
        let SelectGoodsLableData = this.$refs.Prod.GoodsLableFormhy
          .SelectGoodsLableData
          ? this.$refs.Prod.GoodsLableFormhy.SelectGoodsLableData
          : []; //商品标签数据
        if (
          this.formData.specProductFlag == 2 &&
          SelectGoodsLableData.length > 0
        ) {
          for (let i = 0; i < SelectGoodsLableData.length; i++) {
            lblID.push(SelectGoodsLableData[i].lblID);
          }
          console.log("商品编码", lblID);
        } else if (
          this.formData.specProductFlag == 4 &&
          SelectCategoryLabelData.length > 0
        ) {
          for (let i = 0; i < SelectCategoryLabelData.length; i++) {
            lblID.push(SelectCategoryLabelData[i].lblID);
          }
          console.log("类别编码", lblID);
        }
        //类别编码数据
        let SelectCategoryData = this.$refs.Prod.searchCategoryFormhy
          .SelectCategoryData
          ? this.$refs.Prod.searchCategoryFormhy.SelectCategoryData
          : [];
        //商品编码数据
        let SelectGoodsData = this.$refs.Prod.GoodsFormhy.SelectGoodsData;
        if (this.formData.specProductFlag == 1 && SelectGoodsData.length > 0) {
          for (let i = 0; i < SelectGoodsData.length; i++) {
            atrrValue.push(SelectGoodsData[i].ProductCode);
          }
          console.log("商品编码", atrrValue);
        } else if (
          this.formData.specProductFlag == 3 &&
          SelectCategoryData.length > 0
        ) {
          for (let i = 0; i < SelectCategoryData.length; i++) {
            atrrValue.push(SelectCategoryData[i].categoryID);
          }
          console.log("产品编码", atrrValue);
        }
      }
      this.shopId = [];
      if (!this.formData.isAllShop && this.formData.listOfSomeStoresl) {
        for (let i = 0; i < this.formData.listOfSomeStoresl.length; i++) {
          this.shopId.push(this.formData.listOfSomeStoresl[i].id);
        }
      }

      let data = {
        campaignName: this.formData.campaignName, //活动名称
        isAllShop: this.formData.isAllShop, //是否全部门店
        compaignKind: "2", //活动类型
        giftGiveMode: 0, //消费行为giftGiveMode=0、消费满赠giftGiveMode=1
        presentedKind: this.formData.presentedKind, //赠送内容
        joinCustomerFlag: this.formData.joinCustomerFlag, //用户类型
        custLvl: this.formData.custLvl.toString(), //会员等级
        sendMaxQty: this.formData.sendMaxQty, //发放数量
        presentedObjID:
          this.formData.presentedKind == 0
            ? this.formData.presentedObjIDqk
            : this.formData.presentedKind == 1
            ? this.formData.presentedObjIDqb
            : this.formData.presentedKind == 2
            ? this.formData.presentedObjID2
            : this.formData.presentedKind == 4
            ? this.formData.presentedObjID4
            : "", //券库id、券包id、积分、彩信id
        smsBody: this.formData.presentedKind == 3 ? this.formData.smsBody : "", //短信
        runTimeFlag: "1",
        runDay: this.formData.runDay, //执行日
        runMonth: this.formData.runMonth, //执行月
        runStartTime:
          this.formData.runTimeFlag == 1 ? this.formData.runStartTime : null, //执行时间
        sendMode: this.formData.sendMode,
        saleLimieFlag: this.formData.saleLimieFlag, //定时发放时销售单限制
        disIntervalDay:
            this.formData.sendMode == 1
                ? this.formData.disIntervalDay
                : null,
        issueTime:
            this.formData.sendMode == 1 ? this.formData.issueTime : null, //执行时间
        CC1: this.formData.ccMap.length > 0 ? this.formData.ccMap[0] : "",
        CC2: this.formData.ccMap.length > 1 ? this.formData.ccMap[1] : "",
        CC3: this.formData.ccMap.length > 2 ? this.formData.ccMap[2] : "",
        shopID: this.formData.isAllShop == 0 ? this.shopId.toString() : [], //部分门店id
        startDate: dateTimes(this.formData.startDate), //开始执行日期
        endDate: dateTimes(this.formData.endDate), //结束执行日期
        atrrValue:
          this.formData.specProductFlag == 1 ||
          this.formData.specProductFlag == 3
            ? atrrValue.toString()
            : "", //特定商品编码（类别编码或者产品编码）
        actLimit:
          this.formData.actLimit == 0
            ? 0
            : this.formData.wholeOrDay == 1
            ? "1"
            : "2", //活动限制
        saleScope: this.formData.saleScope, //销售单范围
        saleLimit: this.formData.saleLimit, //销售单限制
        specProductFlag:
          this.formData.saleLimit == 3 ? this.formData.specProductFlag : 0,
        lblID:
          this.formData.specProductFlag == 2 ||
          this.formData.specProductFlag == 4
            ? lblID.toString()
            : "", //特定商品编码（类别编码或者产品编码）
        limitNum: this.formData.actLimit != 0 ? this.formData.limitNum : null, //次数
        customerGrpID:
          this.formData.joinCustomerFlag == 14
            ? this.formData.customerGrpID
            : "", //会员分组id
        maxAmount: this.formData.maxAmount, //最大消费金额
        minAmount: this.formData.minAmount, //最小消费金额
      };
      if (this.flag == 2) {
        console.log("修改");
        data.campaignID = this.formData.campaignID;
        data.state = this.formData.state;
        marketingEitApi(data).then((res) => {
          if (res.success !== true) {
            this.$message.error("修改活动失败!");
            return;
          } else {
            this.$message.success("修改活动成功!");
            this.success();
            // 隐藏创建弹窗
          }
        });
      } else {
        marketingInsertApi(data).then((res) => {
          if (res.success !== true) {
            this.$message.error("创建活动失败!");
            return;
          } else {
            this.$message.success("创建活动成功!");
            this.success();

            // 隐藏创建弹窗
          }
        });
      }
    },
    // 获取区域门店
    ShopqueryRegionList() {
      shopQueryRegionApi().then((res) => {
        let arr1 = [],
          arr2 = [];
        if (res.success) {
          res.data.forEach((item) => {
            if (item.chlidren.length > 0) this.StoredataArray.push(item);
          });
          this.StoredataArray.forEach((item, index) => {
            item.chlidren.forEach((item) => {
              item.ShopID = item.id;
            });
            this.StoreSelectLength += 1;
            if (index % 2 == 0) {
              arr1.push(item);
            } else {
              arr2.push(item);
            }
          });
          this.StoreSelectionList = arr1.map((key, value) => [
            key,
            arr2[value],
          ]);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 选择门店
    ComButtomStore() {
      //获取已选择的门店数据
      this.formData.listOfSomeStoresl = [];
      this.formData.listOfSomeStoreslStr = "";
      for (let index = 0; index < this.StoreSelectLength; index++) {
        let item = this.$refs.tree[index].getCheckedNodes();
        if (item.length == this.StoredataArray[index].chlidren.length + 1) {
          this.formData.listOfSomeStoresl.push(
            ...this.StoredataArray[index].chlidren
          );
        } else {
          this.formData.listOfSomeStoresl.push(...item);
        }
      }
      this.formData.listOfSomeStoresl.forEach((item) => {
        this.formData.listOfSomeStoreslStr += `${item.lable}\n`;
      });
      console.log(this.StoreSelectLength);

      // this.formData.listOfSomeStoreslStr =
      //   this.formData.listOfSomeStoreslStr.substring(
      //     0,
      //     this.formData.listOfSomeStoreslStr.length - 2
      //   );
      this.shopId = [];
      for (let i = 0; i < this.formData.listOfSomeStoresl.length; i++) {
        this.shopId.push(this.formData.listOfSomeStoresl[i].id);
      }
      this.outletVisible = false;
    },
    // 选择员工确定事件
    Selectemployees() {
      this.formData.chaosong = "";
      this.formData.ccMap = [];
      this.arrry.forEach((item) => {
        this.formData.chaosong += item.custName + ",";
        this.formData.ccMap.push(item.custID);
        // console.log(item.empName)
      });
      console.log("CCID", this.formData.ccMap);
      this.formData.chaosong = this.formData.chaosong.substring(
        0,
        this.formData.chaosong.length - 1
      );
      this.innerVisiblery = false;
    },
    //控制选择人员列表最多选择三个
    handleSelectionChange(selection, index) {
      this.checkNumber = selection.length;
      if (this.checkNumber >= 4) {
        this.$message({
          message: "只能选中3个!",
          type: "warning",
        });
        this.$refs.multipleTable.toggleRowSelection(index, false);
        selection.length = 3;
      }
      this.arrry = selection;
      console.log("arr", this.arrry);
    },
    // 选择人员数据请求
    async sysempselectEmpList() {
      await custselectCustList(this.queryArrry).then((res) => {
        this.queryListry = res.data.list;
        this.queryArrry.pages = res.data.pages;
        this.loadingry = false;
      });
    },
    // 券包点击跳转查看详情
    Juanbaobtn() {
      if (this.formData.presentedObjIDqb) {
        this.quanbaoShow = true;
        this.$nextTick(() => {
          this.$refs.quanbao.Rcouppacketview(this.formData.presentedObjIDqb);
        });
        // this.$router.push({
        //   path: "/VoucherSee",
        //   query: {
        //     mobile: this.formData.presentedObjID,
        //   },
        // });
      }
    },
    // 选择券包弹窗radio选中数据
    handleRadioChangeqb(val) {
      console.log(val);
      this.templateiqb = val;
    },
    // 获取券包数据
    async Securitieslibraryqb() {
      await couppacketJuanApi(this.queryArrqb).then((res) => {
        this.queryListqb = res.data.list;
        this.queryArrqb.pages = res.data.pages;
        this.loadingqb = false;
      });
    },
    //点击选中劵库获取数据
    weachTherqb() {
      this.Securitieslibraryqb();
      this.innerVisibleqb = true;
    },
    // 选择券包确定事件
    Determineqb() {
      this.formData.presentedqb = this.templateiqb.coupPacketName;
      this.formData.presentedObjIDqb = this.templateiqb.coupPacketID;
      this.radioId = "";
      this.innerVisibleqb = false;
    },
    //券包触底加载
    loadqb() {
      this.loading = true;
      setTimeout(() => {
        this.queryArrqb.pageSize += 50; //页数据+50
        this.Securitieslibraryqb(); // 重新获取数据，此时页数据+50
      });
    },
    // 券包查询
    Seachbtnerqb() {
      this.Securitieslibraryqb();
    },
    // 券库点击跳转
    Juankubtn() {
      if (this.formData.presentedObjIDqk) {
        this.quankuShow = true;
        this.$nextTick(() => {
          this.$refs.quanku.RcouponsGroupDetail(this.formData.presentedObjIDqk);
        });
        // this.$router.push({
        //   path: "/ViewDetails",
        //   query: {
        //     mm: this.formData.presentedObjIDqk,
        //   },
        // });
      } else {
        return;
        // console.log("1111")
      }
    },
    // 选择券库弹窗radio选中数据
    handleRadioChange(val) {
      console.log(val);
      this.templatei = val;
    },
    // 选择券库确定事件
    determine() {
      this.couponsKind = this.templatei.couponsKind;
      // this.formData.presentedqk = this.templatei.couponsName;
      this.$set(this.formData, "presentedqk", this.templatei.couponsName);
      this.formData.presentedObjIDqk = this.templatei.couponsGrpID;
      this.radioId = "";
      this.innerVisible = false;
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    load() {
      this.loading = true;
      setTimeout(() => {
        this.queryArr.pageSize += 50; //页数据+50
        this.Securitieslibrary(); // 重新获取数据，此时页数据+50
      });
    },
    //选择劵库数据请求
    async Securitieslibrary() {
      await couponsGroupApi(this.queryArr).then((res) => {
        this.queryList = res.data.list;
        this.queryArr.pages = res.data.pages;
        this.loading = false;
      });
    },
    //点击选中劵库获取数据
    weachTher() {
      this.Securitieslibrary();
      this.innerVisible = true;
    },
    shopRadioChange(index) {
      if (index == 0) {
        this.radioChangeShop = false;
      } else {
        this.radioChangeShop = true;
      }
    },
    sendModeRadioChange(index) {
      if (index == 0) {
        this.formData.disIntervalDay = '';
        this.formData.issueTime = '';
        this.formData.saleLimieFlag = '';
      } else {
        this.formData.saleLimieFlag = 0;
        this.formData.disIntervalDay = 1;
      }
    },
    // 选择门店
    shopOpen() {
      this.selectStoreDialog = true;
      this.shopRegionList();
    },

    // tree门店列表数据
    shopRegionList() {
      shopQueryRegionApi().then((res) => {
        if (res.success) {
          this.selectShopData = res.data;
          console.log(res, "选择门店");
        }
      });
    },
    // 选中的门店数据
    ComButtonStore() {
      console.log(this.$refs.tree.getCheckedKeys(), "getCheckedKeys");
      console.log(this.$refs.tree.getCheckedNodes(), "getCheckedNodes");
      // let str = "";
      for (let i = 0; i < this.$refs.tree.getCheckedNodes().length; i++) {
        this.formData.shopID += this.$refs.tree.getCheckedNodes()[i].lable;
      }
      this.selectStoreDialog = false;
    },
    parentHandleclick(e) {

      if (!e) {
        this.formData = {
          couponsKind: "",
          campaignName: "",
          isAllShop: true,
          custLvl: [],
          CCID: [],
          runTimeFlag: 0,
          sendMode: 0,
          saleLimieFlag: '',
          disIntervalDay: '',
          issueTime: '',
          presentedKind: 0,
          chaosong: "",
          listOfSomeStoresl: [],
          ccMap: [],
          actLimit: 0,
          saleLimit: 0,
          saleScope: 0,
          specProductFlag: "1",
          custGrpName: "",
          customerGrpID: "",
        };
        this.shopId = [];
        return;
      }

      if (e.flag == 2 || e.flag == 3) {

        this.flag = e.flag;
        this.formData.campaignID = e.data.campaignID;
        this.formData.state = e.data.state;
      } else {
        this.flag = 0;
      }
      if (e.message == "success") {
        this.formData = e.data;

        if (e.data.actLimit != 0) {
          this.formData.wholeOrDay = e.data.actLimit + "";

          this.formData.actLimit = 3;
        }

        this.formData.specProductFlag = e.data.specProductFlag + "";

        if(e.data.specProductFlag!=null && e.data.specProductFlag!='null' ){
        this.$nextTick(() => {
          this.$refs.Prod.parentHandleclick(e.data.specProductFlag, e.flag);
        });
        if (e.data.specProductFlag == 4) {
          this.$nextTick(() => {
            this.$refs.Prod.searchCategoryLabelFormhy.SelectCategoryLabelData =
              e.lblList;
          });
        } else if (e.data.specProductFlag == 2) {
          this.$nextTick(() => {
            this.$refs.Prod.GoodsLableFormhy.SelectGoodsLableData = e.lblList;
          });
        } else if (e.data.specProductFlag == 1) {
          this.$nextTick(() => {
            this.$refs.Prod.GoodsFormhy.SelectGoodsData = e.atrrValueList;
          });
        } else if (e.data.specProductFlag == 3) {
          this.$nextTick(() => {
            this.$refs.Prod.searchCategoryFormhy.SelectCategoryData =
              e.atrrValueList;
          });
        }
        }
        let array1 = [];
        for (let i = 0; i < e.custLvl.length; i++) {
          array1.push(e.custLvl[i].LevelID);
        }
        this.$set(this.formData, "custLvl", array1);
        this.formData.listOfSomeStoreslStr = "";
        this.shopId = [];
        this.formData.listOfSomeStoresl = [];
        for (let i = 0; i < e.shopList.length; i++) {
          this.shopId.push(e.shopList[i].ShopID);
          this.formData.listOfSomeStoreslStr += `${e.shopList[i].ShopName}\n`;
          let str = {
            shopID: e.shopList[i].ShopID,
            id: e.shopList[i].ShopID,
          };
          this.formData.listOfSomeStoresl.push(str);
        }

        if (e.data.presentedKind == 0) {
          this.$set(this.formData, "presentedqk", e.data.couponsName);
          this.$set(this.formData, "presentedObjIDqk", e.data.presentedObjID);
        } else if (e.data.presentedKind == 1) {
          this.$set(this.formData, "presentedqb", e.data.coupPacketName);
          this.$set(this.formData, "presentedObjIDqb", e.data.presentedObjID);
        } else if (e.data.presentedKind == 2) {
          this.$set(this.formData, "presentedObjID2", e.data.presentedObjID);
        } else if (e.data.presentedKind == 4) {
          this.$set(this.formData, "presentedObjID4", e.data.presentedObjID);
        }
        this.formData.ccMap = [];
        this.formData.ccMap.push(e.data.cc1);
        this.formData.ccMap.push(e.data.cc2);
        this.formData.ccMap.push(e.data.cc3);
        this.formData.chaosong =
          e.data.cc1Name + "," + e.data.cc2Name + "," + e.data.cc3Name;
      } else {
        this.formData = {
          actLimit: 0,
          saleLimit: 0,
          saleScope: 0,
          campaignName: "",
          isAllShop: true,
          custLvl: [],
          runTimeFlag: 0,
          sendMode: 0,
          saleLimieFlag: '',
          disIntervalDay: '',
          issueTime: '',
          presentedKind: 0,
        };
      }
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-dialog__header {
  padding: 1.25rem 1.25rem 0.625rem;
  background-color: #d1cda5;
}
.dialog-footer {
  height: 40px;
  display: flex;
  justify-content: space-around;
}
/deep/.el-dialog__footer {
  height: 60px;
  text-align: center;
  background-color: #f2f2f2;
}
.el-button:hover {
  background-color: #b5b386;
  color: #f2f2f2;
}
/deep/.xiaoguo .el-input .el-input__inner {
  color: blue;
  text-decoration: underline;
}
</style>
